import React, { useEffect, useRef, useContext } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { ObserverContext } from "../../Contexts/ObserverContext";

import team1 from "../../assets/NT1.png";
import team2 from "../../assets/NT2.png";
import team3 from "../../assets/NT3.png";
import team4 from "../../assets/NT4.png";
import team5 from "../../assets/NT5.png";
import team7 from "../../assets/t7.png";

function Team() {
  const ref = useRef();
  const { setActiveSection } = useContext(ObserverContext);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setActiveSection("team");
        }
      },
      { threshold: 0.3 },
    );

    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [setActiveSection]);

  const teamMembers = [
    {
      name: "Jashinder Bir Singh",
      role: "Founder",
      image: team1,
      linkedin: "https://www.linkedin.com/in/jashinder-bir-singh-3a130b27/",
    },
    {
      name: "Chandandeep Kaur",
      role: "Director Co-Founder",
      image: team2,
      linkedin: "https://www.linkedin.com/in/chandandeep-kaur-8378b9106/",
    },
    {
      name: "Onkar Dhar",
      role: "Director Sales",
      image: team4,
      linkedin: "https://www.linkedin.com/in/onkar-dhar-6726a518/",
    },
    {
      name: "Rajan Vasudev",
      role: "Director Finance",
      image: team5,
    },
    {
      name: "Ashwani Prabhakar",
      role: "General Manager Delivery",
      image: team3,
    },
    {
      name: "Yashkirat Singh",
      role: "Chief Strategy Officer",
      image: team7,
      linkedin: "https://www.linkedin.com/in/yashkirat-singh-075074109/",
    },
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 600,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 3 },
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 480,
        settings: { slidesToShow: 1 },
      },
    ],
  };

  return (
    <section className="team-section" id="team" ref={ref}>
      {/* 🔥 Internal CSS */}
      <style>{`
        .team-section {
          padding: 60px 20px;
          text-align: center;
          background: #f9fafc;
        }

        .team-section h2 {
          font-size: 36px;
          margin-bottom: 10px;
          font-weight: 700;
        }

        .team-section p {
          color: #666;
          margin-bottom: 40px;
        }

        .team-card {
          padding: 15px;
          transition: transform 0.3s ease;
        }

        .team-card:hover {
          transform: translateY(-8px);
        }

     .image-container {
  position: relative;
  overflow: hidden;
  border-radius: 14px;
  height: 360px;        
}

.image-container img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center top;  
  transition: transform 0.4s ease;
}

        .image-container:hover img {
          transform: scale(1.05);
        }

        .linkedin-link {
          position: absolute;
          bottom: 15px;
          left: 50%;
          transform: translateX(-50%);
          background: #0a66c2;
          color: #fff;
          padding: 6px 14px;
          border-radius: 20px;
          font-size: 12px;
          text-decoration: none;
          opacity: 0;
          transition: 0.3s ease;
        }

        .image-container:hover .linkedin-link {
          opacity: 1;
        }

        .team-detail {
          margin-top: 12px;
        }

        .team-detail h5 {
          font-size: 18px;
          margin: 5px 0;
          font-weight: 600;
        }

        .team-detail p {
          font-size: 14px;
          color: #777;
        }

        .slick-dots li button:before {
          color: #0a66c2;
        }

        .slick-dots li.slick-active button:before {
          color: #0a66c2;
        }
      `}</style>

      <h2 style={{ marginTop: "30px" }}>Meet The Team</h2>
      <p>
        With over 153 years of combined experience, we've got a well-seasoned
        team at the helm.
      </p>

      <Slider {...settings}>
        {teamMembers.map((member, index) => (
          <div key={index} className="team-card">
            <div className="image-container">
              <img src={member.image} alt={member.name} />
              {member.linkedin && (
                <a
                  href={member.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="linkedin-link"
                >
                  View on LinkedIn
                </a>
              )}
            </div>
            <div className="team-detail">
              <h5>{member.name}</h5>
              <p>{member.role}</p>
            </div>
          </div>
        ))}
      </Slider>
    </section>
  );
}

export default Team;
